import { useState, useEffect } from 'react'
import { Cpu, HardDrive, ShieldCheck, ShieldOff, Loader2 } from 'lucide-react'
import { get } from '../utils/api'

function Row({ icon, label, value }) {
  return (
    <div className="flex items-center justify-between text-[11px]">
      <span className="flex items-center gap-1.5 text-gray-400">
        {icon}
        {label}
      </span>
      <span className="font-medium text-gray-700 truncate max-w-[110px]">{value}</span>
    </div>
  )
}

export default function WebsiteStatsCard({ domain }) {
  const [site, setSite]       = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!domain) return
    let cancelled = false
    setLoading(true)
    get(`/websites/${domain}`).then((res) => {
      if (!cancelled && res?.success) setSite(res.data)
    }).catch(() => {}).finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [domain])

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-[11px] text-gray-400 px-0.5">
        <Loader2 size={11} className="animate-spin" /> Loading stats…
      </div>
    )
  }

  if (!site) return null

  return (
    <div className="space-y-1.5 px-0.5">
      <Row icon={<Cpu size={12} />} label="PHP" value={site.php_version || '—'} />
      <Row icon={<HardDrive size={12} />} label="Disk" value={site.disk_used_mb != null ? `${site.disk_used_mb} MB` : '—'} />
      <Row
        icon={site.ssl_enabled ? <ShieldCheck size={12} className="text-green-500" /> : <ShieldOff size={12} />}
        label="SSL"
        value={site.ssl_enabled ? 'Enabled' : 'Disabled'}
      />
      <Row icon={<span className={`inline-block w-1.5 h-1.5 rounded-full ${site.state === 'active' ? 'bg-green-500' : 'bg-gray-300'}`} />} label="Status" value={site.state || '—'} />
    </div>
  )
}
